module.exports = __webpack_public_path__ + "img/szfw-swfw.d08300fd.png";